<template>
  <v-container
    class="d-flex justify-center align-center"
    style="min-height: 100vh;"
  >
    <div class="text-center">
      <div class="mb-4">
        <img :src="logo" height="40" />
      </div>

      <p class="body-1 blue-grey-darken-3 font-size-16 font-weight-400">
        {{ $t('redirect.title') }}
      </p>
    </div>
  </v-container>
</template>

<script>
import config from '@/config.js'

import Logo from '@/assets/logo.svg'

export default {
  name: 'RedirectView',

  data() {
    return {
      logo: Logo,
    }
  },

  created() {
    setTimeout(() => {
      window.location.replace(`${config.web}/access`)
    }, 500)
  },
}
</script>
